import { stringToBinary } from 'libs/utils/string';
export async function stringToSha256(value) {
  const buffer = stringToBinary(value);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
}
export function encryptEmail(email) {
  return stringToSha256(email.toLowerCase().replace(/\+[^@]*@/, '@'));
}